import React, { ReactNode } from "react"

interface ContactFormFieldWrapperProps {
  children: ReactNode
  size: string
}

const ContactFormFieldWrapper: React.FC<ContactFormFieldWrapperProps> = ({
  children,
  size,
}) => {
  return (
    <div className={`w-full md:w-${size === "1/2" ? "1/2" : "full"} p-2`}>
      {children}
    </div>
  )
}

export default ContactFormFieldWrapper
